// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// *************************************************************** forgives assignment *****************************************************************
const GET_FORGIVENESS_USER_ASSIGNMENT_SUCCESS = 'GET_FORGIVENESS_USER_ASSIGNMENT_SUCCESS';

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// *************************************************************** forgives assignment *****************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @param {String} component
 * @return {{type: String, payload: Object}}
 * @private
 */
function _getSuccess(payload, component = 'Data') {
  let forgive = [];
  let positions = [];
  if (component === 'User') {
    forgive = payload.data.user.forgive;
    positions = payload.data.user.positions;
  } else {
    forgive = [];
    positions = [payload.data];
  }

  return {
    type: GET_FORGIVENESS_USER_ASSIGNMENT_SUCCESS,
    payload: {forgive, positions},
  };
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyforgive() {
  return _getSuccess({data: {forgive: []}});
}


// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// *************************************************************** forgive assignment *****************************************************************

/**
 *
 * @param {String} component
 * @param {Number} id
 * @return {string}
 */
function getRoute(component = 'User', id = 0) {

  let route = `/users/${id}/forgive`;
  if (component === 'position') {
    route = `/positions/${id}/forgive`;
  }
  return route;
}

/**
 *
 * @param {String} component
 * @param {Number} user
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(component = 'User', user, params = {}, callback = () => {
}) {
  return (dispatch, gs, api) => {
    //if (app.can('forgiveAssignment@update')) {
      if (app.can('forgive@assignforgive')) {

      let route = getRoute(component, user);

      api.get(route, {params})
        .then((res) => {
          dispatch(_getSuccess(res, component));
          callback(undefined, res);
        })
        .catch((err) => {
          callback(err);
        });
    }
  };
}


/**
 *
 * @param {Object} [data={}]
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function store(data, params = {}, callback = () => {
}) {
  return (dispatch, gs, api) => {
    //if (app.can('forgiveAssignment@update')) {
      if (app.can('forgive@assignforgive')) {
        let loader = app.loading(app.translate('routes.home.attendance.shift.Shift Assignment'));
      api.post(`/ta/shascaifts/assignment`, {data: {data: data}, params})
        .then((res) => {
          dispatch(_getSuccess(res));
          loader.hide(() => app.message(app.translate('routes.home.attendance.shift.Shift Assigned Successfully')));
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() => app.error(
            err, 'routes.home.attendance.shift', 'خطا در ارسال اطلاعات',
            app.translate('routes.home.attendance.shift.Shift Assignment Failed'),
          ));
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Number} shift
 * @param {Object} [data={}]
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function changeShift(shift, data, params = {}, callback = () => {
}) {
  return (dispatch, gs, api) => {
    //if (app.can('ShiftAssignment@update')) {
      if (app.can('Shift@assignShift')) {

      api.put(`/ta/forgive/${shift}/positions`, {data: {shift: data}, params})
        .then((res) => {
          dispatch(_getSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          callback(err);
        });
    }
  };
}


/**
 *
 * @param {Object} [data={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function assignShift(data, callback = () => {
}) {
  return (dispatch, gs, api) => {
    //if (app.can('ShiftAssignment@update')) {
    if (app.can('')) {
      let loader = app.loading(app.translate('در حال انتساب بخشودگی'));
      api.post(`/ForgivenessPosition/Add`, {data:  data})
        .then((res) => {
          loader.hide(() => app.message(app.translate('انتساب با موفقیت انجام شد')));
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() => app.error(
              err, 'routes.home.attendance.shift', 'انتساب بخشودگی شکست خورد',
              app.translate('routes.home.attendance.shift.Check Shift Assignment Failed'),
          ));
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Object} [data={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function checkAssignShift(data, callback = () => {
}) {
  return (dispatch, gs, api) => {
    //if (app.can('ShiftAssignment@update')) {
      if (app.can('Shift@assignShift')) {
        let loader = app.loading(app.translate('routes.home.attendance.shift.Check Shift Assignment'));
      api.post(`/ta/forgive/check_assign`, {data:  data})
        .then((res) => {
          loader.hide(() => app.message(app.translate('routes.home.attendance.shift.Check Shift Assignment successfully')));
          dispatch(_getSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() => app.error(
              err, 'routes.home.attendance.shift', 'خطا در ارسال اطلاعات',
              app.translate('routes.home.attendance.shift.Check Shift Assignment Failed'),
          ));
          callback(err);
        });
    }
  };
}


// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(state = {
  userforgive: [],
  positionforgive: [],
}, action) {

  switch (action.type) {
    case GET_FORGIVENESS_USER_ASSIGNMENT_SUCCESS:
      return Object.assign({}, state, {
        userforgive: action.payload.forgive,
        positionforgive: action.payload.positions,
      });
    default:
      return state;
  }
}
